module.exports = __webpack_public_path__ + "media/images/jumping/ing-m-220b28706a8d4840eb37eeac509d5ae1.png";